module.exports = __webpack_public_path__ + "static/media/tales-of-egypt.bdea0f1a.gif";